import angular from "angular";
import moment from "moment/moment";

angular
    .module('ui-sentinel.watchlist')
    .factory('WatchlistTrackingReportsService', WatchlistTrackingReportsService);

WatchlistTrackingReportsService.$inject = ['$rootScope', 'SentinelUiSession', 'localStorageService', 'WatchlistsService', 'DatetimeValidatorService', 'BatteryPercentageService', 'FeedbackService'];

function WatchlistTrackingReportsService($rootScope, SentinelUiSession, localStorageService, WatchlistsService, DatetimeValidatorService, BatteryPercentageService, FeedbackService) {
    const maxPageSize = 5000;
    const maxReportCapacity = 150000;
    let totalCount = 0;
    const localStorageKey = 'watchlistTrackingReportsService';

    const service = {
        feedback: FeedbackService,
        lastClientGuid: null,
        reports: [],
        selected: null,
        load: load,
        get: get,
        fromDate: moment().subtract(7, 'day').startOf('day'),
        toDate: moment().add(1, 'day').endOf('day'),
        watchlist: null,
        sentinel: null,
        isFull: false,
        clear: clear
    };
    activate();
    return service;

    ///////////////////////////////////////////////////

    function activate() {
        //in case this is a page reload event, check the local storage for 'cached' dates and use those
        const cachedDateRange = localStorageService.get(localStorageKey);
        if (cachedDateRange) {
            service.fromDate = moment(cachedDateRange.fromDate);
            service.toDate = moment(cachedDateRange.toDate);
        }

        $rootScope.$on('CLIENT_FOCUS_CHANGED', function (event, args) {
            clear();
        });
    }

    function clear() {
        service.lastClientGuid = null;
        service.selected = null;
        service.reports = [];
        service.isFull = false;
        service.fromDate = moment().subtract(7, 'day').startOf('day');
        service.toDate = moment().add(1, 'day').endOf('day');
    }

    function floorFigure(figure, decimals) {
        if (!decimals) decimals = 2;
        const d = Math.pow(10, decimals);
        return (parseInt(figure * d) / d).toFixed(decimals);
    }

    function load(watchlist, fromDate, toDate, refresh) {
        if (!watchlist || !fromDate || !toDate) {
            clear();
            return;
        }

        const oneYearAgo = moment().subtract(1, 'year');
        let fromMoment = moment.isMoment(fromDate) ? fromDate : moment(fromDate);
        let toMoment = moment.isMoment(toDate) ? toDate : moment(toDate);
        let maxToMoment = moment();

        if (fromMoment.isBefore(oneYearAgo)) {
            fromMoment = oneYearAgo;
        }

        if (toMoment.isAfter(maxToMoment)) {
            toMoment = maxToMoment;
        }

        if (!refresh && service.lastClientGuid === SentinelUiSession.focus.id &&
            fromMoment.isSame(service.fromDate) && toMoment.isSame(service.toDate)) {
            //do not reload the same data set again
            return;
        }

        $rootScope.loading = true;

        service.lastid = SentinelUiSession.focus.id;
        service.selected = null;
        service.fromDate = fromMoment;
        service.toDate = toMoment;
        service.watchlist = watchlist;
        totalCount = 0;

        const cachedDateRange = {
            fromDate: service.fromDate.toISOString(),
            toDate: service.toDate.toISOString()
        };
        localStorageService.set(localStorageKey, cachedDateRange);
        LoadLogData(1, 0, watchlist);
    }

    function LoadLogData(pagenum, totalCount, watchlist) {

        let hasMoreData = true;

        const promise = WatchlistsService.getWatchlistLogData(watchlist.id, pagenum, maxPageSize, service.fromDate, service.toDate).$promise;

        promise.then(
            function (results) {
                _.forEach(results, function (item) {
                    item.type = "Sentinel";
                    item.severity = "ok";
                    item.locationMethod = "gps";
                    item.messageTimeStamp = item.timeOfReport;
                    item.lastReport = item.timeOfReport;
                    item.batteryPercent = BatteryPercentageService.calc(item.batteryVoltage, item.beaconType);
                    item.isShockExceeded = item.shockMagnitude != null || (item.shockX != null && item.shockY != null && item.shockZ != null);
                    if (item.isShockExceeded && item.shockMagnitude == null) {
                        item.shockMagnitude = Math.sqrt(Math.pow(item.shockX, 2) + Math.pow(item.shockY, 2) + Math.pow(item.shockZ, 2)).toFixed(1);
                    }
                });

                if (pagenum === 1) {
                    totalCount = results.length;
                    service.reports = [];
                } else {
                    totalCount = totalCount + results.length;
                }

                service.reports = service.reports.concat(results);
                service.isFull = totalCount >= maxReportCapacity;

                hasMoreData = ((results.length == 5000) && (!service.isFull));
                pagenum++;
            },
            function (error) {
                hasMoreData = false;
                console.error(error);
                service.feedback.addErrorFromError('Error loading watchlist reports.');
            }
        )
            .finally(function () {
                if (hasMoreData)
                    LoadLogData(pagenum, totalCount, watchlist);
                else {
                    for (let x = service.reports.length - 2; x >= 0; x--) {
                        service.reports[x].lastReport = service.reports[x + 1].timeOfReport;
                        const dif = moment.duration(moment(service.reports[x].timeOfReport).diff(moment(service.reports[x].lastReport), 'milliseconds'));
                        service.reports[x].timeDiff = convertMilliSecondsIntoLegibleString(dif.asMilliseconds());
                    }

                    $rootScope.loading = false;
                }
            });
    }

    function convertMilliSecondsIntoLegibleString(milliSecondsIn) {

        const secsIn = milliSecondsIn / 1000;
        const milliSecs = milliSecondsIn % 1000;

        const hours = secsIn / 3600,
            remainder = secsIn % 3600,
            minutes = remainder / 60,
            seconds = remainder % 60;

        return (String(hours.toFixed(0)).padStart(2, '0') + ":" + String(minutes.toFixed(0)).padStart(2, '0') + ":" + String(seconds.toFixed(0)).padStart(2, '0'));
    }

    function get(guid) {
        let result = null;
        _.forEach(service.reports, function (report) {
            if (report.sentinelLogDataId == guid) {
                result = report;
                return false;
            }
        });
        return result;
    }
}
